class DropdownToggle {
  constructor() {
    this.$body = $('body')
    if (this.$body.find('.dropdown__container').length) {
      this.initialize();
    }
  }

  initialize() {
    $(document).on('click', '[data-role="dropdown-toggle"]', (e) => {
      e.preventDefault();
      $(e.currentTarget)
        .parent('.dropdown__container')
        .toggleClass('open')
        .siblings()
        .removeClass('open')
    });

    $(document).on('click', (e) => {
      if ($(e.target).hasClass('dropdown__container')) {
        $(e.target).removeClass('open');
      }
    });
  }
}

export default DropdownToggle;



// WEBPACK FOOTER //
// ./scripts/navigation/DropdownToggle.js